import { useTranslations } from 'next-intl';

import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import PageBuilder from '@commons/pagebuilder';

import type { DrupalInsightsView } from '.';

/**
 * Latest display of the insights view.
 *
 * Renders a set of insights from the latest insights view.
 */

const LatestDisplay = ({ content }: DrupalInsightsView) => {
  const t = useTranslations('views');

  const isEmpty = content.length == 0;
  const renderedContent = content.map((node) => (
    <Flex.Item width={12} border="top" paddingTop="xs" key={node.id}>
      {PageBuilder.renderNode(node)}
    </Flex.Item>
  ));

  return (
    <Flex gap="sm" direction="column">
      {!isEmpty ? renderedContent : <Text as="p">{t('noResult')}</Text>}
    </Flex>
  );
};

export default LatestDisplay;
